export const environment = {
  production: false,
  apiUrl: 'https://api.vigilantpass.dev',
  stripePublishableKey: "pk_test_51Oj3EVEXGQXNpeXXVrVfY5uSiRf0VTJ5d92B7oUpq3PeIaBIEvPTrxgwkqM7n05oBKX1wA502CbUmARC4akexSvD00bFicHm8N"
};
